<div v-if="item" class="tt-o-byline tt-u-spacing--left--xs">
  <!--<a href="" class="tt-o-byline__item tt-o-byline__action" @click.prevent="selectedAuthor" rel="nofollow">{{formatUserName(item.user)}}</a>-->
  <span v-if="item.user" class="tt-o-byline__item tt-o-byline__author">{{formatUserName(item.user)}}</span>
  <tt-badge v-for="badge in badges" :type="badge.type" :key="badge.type" v-html="badge.label"></tt-badge>
  <time v-if="dateCreatedFormatted" :datetime="dateTime" class="tt-o-byline__item tt-o-byline__on-date">{{ dateCreatedFormatted }}</time>
</div>
